import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import useTournamentDetails from '@/hooks/useTournamentDetails';
import { useState } from 'react';
import SearchablePlayerSelect from './SearchablePlayerSelect';

const UnregisterPlayerModal = ({
  onSubmit,
  onClose,
  title,
  tournamentId,
}: {
  onSubmit: (playerId: string) => void;
  onClose: () => void;
  title: string;
  tournamentId: string;
}) => {
  const { players } = useTournamentDetails(tournamentId);
  const [selectedPlayer, setSelectedPlayer] = useState<string | null>(null);

  const handleSubmit = () => {
    if (!selectedPlayer) {
      return;
    }

    const player = players?.players?.find((player) => player.userId === selectedPlayer);
    if (!player) {
      return;
    }

    onSubmit(player.userId);
  };

  return (
    <Modal isOpen toggle={onClose} id="unregister-player-modal" className="modal-md" centered>
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody className="d-flex flex-column gap-4">
        <div>
          <p className="mb-2">Select Player to Unregister</p>
          <SearchablePlayerSelect
            players={players?.players}
            selectedPlayerId={selectedPlayer}
            onPlayerSelect={setSelectedPlayer}
            placeholder="Search for a player to unregister..."
          />
        </div>

        <div className="alert alert-warning" role="alert">
          <strong>Warning:</strong> This action will permanently unregister the selected player from the tournament and
          cannot be undone.
        </div>

        <Button disabled={!selectedPlayer} color="danger" onClick={handleSubmit}>
          Unregister Player
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default UnregisterPlayerModal;
